export var DEPLOY_DATE = new Date('2026-01-15T10:52:29+0000');
